import { convertToArabicNumbers, convertToEnglishNumbers } from "./language-helper";


function convertEgpToUsd(egpPrice: string | number, exchangeRate: number = 50): number {
    const priceInEnglish = convertToEnglishNumbers(String(egpPrice));
    const priceNumber = Number(priceInEnglish);
    if (isNaN(priceNumber)) {
      throw new Error("Invalid price input");
    }
    return priceNumber / exchangeRate;
  }

function convertUsdToEgp(usdPrice: string | number, exchangeRate: number = 50): number {
    const priceInEnglish = convertToEnglishNumbers(String(usdPrice));
    const priceNumber = Number(priceInEnglish);
    if (isNaN(priceNumber)) {
      throw new Error("Invalid price input");
    }
    return priceNumber * exchangeRate;
  }
  

export function calculateTotalPriceForSliderSection(sliderValue: number): number {
    // Calculate price based on slider value
    const rawPrice = 1000 + 30 * (sliderValue - 10);
    // Clamp price between 1000 and 5000
    const clampedPrice = Math.max(Math.min(rawPrice, 5000), 1000);
    return clampedPrice;
  }


  export async function formatPrice(
    locale: string, 
    index: number, 
    item: any, 
    country: string | null,
    sliderValue?: number,
  ): Promise<string> {
    const isArabic = locale === "ar";
    const isEgypt = country === "Egypt";
  
    const formatNumber = (num: number | string) => {
        if (num === undefined || num === null || (typeof num === 'number' && isNaN(num))) {
          return '';
        }
        return isArabic ? convertToArabicNumbers(num) : num;
      };
      
    const formatCurrency = (value: number | string, currency: string) =>
       `${formatNumber(value)} ${currency}`;
    
  
    const dollarCurrency = isArabic ? "دولار" : "$";
    const egpCurrency = isArabic ? "جنيه" : "EGP";
  
    // Calculate total price for Pro plan slider
    if (index === 1 && sliderValue !== undefined) {
      const totalPrice = calculateTotalPriceForSliderSection(sliderValue);
      const totalPriceDollar = convertEgpToUsd(totalPrice);
  
      return isEgypt
        ? formatCurrency(Math.round(totalPrice), egpCurrency)
        : formatCurrency(Math.round(totalPriceDollar), dollarCurrency);
    }
  
    // For other plans, use base price

    const basePrice = Number(convertToEnglishNumbers(String(item.price)));
    const safeBasePrice = Number(basePrice) || 0;
    const safeBasePriceInDollar = Number(convertEgpToUsd(basePrice)) || 0;

    return isEgypt
        ? formatCurrency(Math.round(safeBasePrice), egpCurrency)
        : formatCurrency(Math.round(safeBasePriceInDollar), dollarCurrency);

  }
